import { render } from "./BaseUploadFileCustom.vue?vue&type=template&id=5b76dce3&ts=true"
import script from "./BaseUploadFileCustom.vue?vue&type=script&lang=ts"
export * from "./BaseUploadFileCustom.vue?vue&type=script&lang=ts"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__